import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Card, CardContent } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import CommonButton from './CommonButton';
import CommonSelect from './CommonSelect';
import CommonSearch from './CommonSearch';
import {
  getPrimaryFilters, getEstimates, getCompanies, getClientsByCompanyCode, getProductsByClientId,
} from '../redux/actions/common';
import { showToast } from '../Utils';

const PrimaryFilters = ({
  fetchCompanies,
  fetchClients,
  fetchProducts,
  clients,
  companies,
  estimates,
  fetchFunction,
  selectedValue,
  visibleProduct,
  visibleEstimate,
  fetchEstimates,
  location,
  showFetchButton,
  productFilter,

}) => {
  const [company, setCompany] = useState(null)
  const [client, setClient] = useState(null)
  const [product, setProduct] = useState(null)
  const [estimate, setEstimate] = useState(null)
  const [fetchButton, enableFetchButton] = useState(true)

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  const handleChangeCompanies = (val) => {
    setCompany(val);
    setClient(null)
    fetchClients(val)
    setProduct(null)
    setEstimate(null)
    enableFetchButton(true)
  }

  const handleChangeClients = (val) => {
    if (val) {
      setClient(val)
      fetchProducts(val.value)
      if (selectedValue) { selectedValue(val); }
    } else {
      setClient(null)
    }
    setProduct(null)
    setEstimate(null)
    enableFetchButton(true)
  }

  const handleChangeProducts = (val) => {
    if (val) {
      setProduct(val)
      if (fetchEstimates) {
        fetchEstimates({ companyCode: company, clientId: client.value, productId: val.value })
      }
    } else {
      setProduct(null)
    }
    setEstimate(null)
    enableFetchButton(true)
  }

  const handleChangeEstimates = (val) => {
    if (val) {
      enableFetchButton(false)
      setEstimate(val)
    } else {
      setEstimate(null)
      enableFetchButton(true)
    }
  }

  const fetchData = () => {
    if (fetchFunction) {
      switch (location) {
        case 'allsites':
          fetchFunction(estimate.estimateId)
          break;
        case 'estimates':
          fetchFunction(product)
          break;
        default:
          break;
      }
    } else {
      showToast('warning', 'Can not perform any task');
    }
  }

  return (
    <Card>
      <br />
      <CardContent>
        <div className="row">
          <div className="col-4">
            <CommonSelect label="Companies" options={companies} handleChange={handleChangeCompanies} />
          </div>
          <div className="col-4">
            <CommonSearch disabled={!company} label="Clients" value={client} data={clients} onChange={handleChangeClients} />
          </div>
          {(visibleProduct) ? (
            <div className="col-4">
              <CommonSearch disabled={!client} label="Products" value={product} data={productFilter} onChange={handleChangeProducts} />
            </div>
          )
            : null}
        </div>
        <div className="row mt-2">
          {(visibleEstimate) ? (
            <div className="col-9">
              <CommonSearch disabled={!product} label="Estimates" value={estimate} data={estimates} onChange={handleChangeEstimates} />
            </div>
          )
            : null}
          {showFetchButton
            ? (
              <div className="col-3">
                <CommonButton
                  className="wide-200"
                  variant="outlined"
                  color="primary"
                  disabled={fetchButton}
                  startIcon={<FilterListIcon />}
                  onClick={() => fetchData()}
                >
                  Fetch Sites
                </CommonButton>
              </div>
            )
            : null }
        </div>
      </CardContent>
    </Card>
  );
};

const mapState = (state) => ({
  clients: state.common.clients,
  companies: state.common.companies,
  estimates: state.common.estimates,
  productFilter: state.common.productFilter,
});

const mapActions = {
  getPFilters: getPrimaryFilters,
  fetchEstimates: getEstimates,
  fetchCompanies: getCompanies,
  fetchClients: getClientsByCompanyCode,
  fetchProducts: getProductsByClientId,
};

export default connect(mapState, mapActions)(PrimaryFilters);
